
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import App from './App';
import SubscriptionShield from './components/SubscriptionShield';
import './index.css';

// Using the same PUBLISHABLE KEY as the main cadops-website instance for seamless session sharing
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || (import.meta.env as any).NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  console.error("CRITICAL: Clerk Publishable Key is missing from the environment.");
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

if (!PUBLISHABLE_KEY) {
  root.render(
    <div style={{ padding: '2rem', backgroundColor: '#fef2f2', color: '#991b1b', border: '1px solid #f87171', margin: '2rem', borderRadius: '0.5rem', fontFamily: 'sans-serif' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>Configuration Error</h1>
      <p>The <code>VITE_CLERK_PUBLISHABLE_KEY</code> is missing from your environment.</p>
      <p style={{ marginTop: '0.5rem', fontSize: '0.875rem' }}>Please ensure you have added it to your Cloudflare Pages Production environment variables and triggered a fresh build.</p>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <SubscriptionShield>
          <App />
        </SubscriptionShield>
      </ClerkProvider>
    </React.StrictMode>
  );
}
